/**
 * Skeleton loader FLUA — shimmer com as cores da marca (primary blue).
 * Substitui spinners genéricos por placeholders que preservam o layout
 * enquanto o dado carrega.
 *
 *   <SkeletonFlua className="h-4 w-32" />               // 1 barra
 *   <SkeletonFlua lines={3} />                           // 3 barras empilhadas
 *   <SkeletonFluaCard />                                 // card completo
 *   <SkeletonFluaRow cols={4} />                         // linha de tabela
 */

export function SkeletonFlua({ className = "", lines = 1 }) {
  if (lines <= 1) {
    return <div className={`flua-skeleton rounded ${className || "h-4 w-full"}`} aria-hidden />;
  }
  return (
    <div className="space-y-2" data-testid="skeleton-flua">
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className={`flua-skeleton rounded h-3 ${i === lines - 1 ? "w-3/4" : "w-full"}`}
          aria-hidden
        />
      ))}
    </div>
  );
}

export function SkeletonFluaCard({ className = "" }) {
  return (
    <div
      className={`rounded-xl border border-border bg-card p-5 space-y-3 ${className}`}
      data-testid="skeleton-flua-card"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flua-skeleton rounded h-3 w-24" />
        <div className="flua-skeleton rounded-lg h-10 w-10" />
      </div>
      <div className="flua-skeleton rounded h-8 w-32" />
      <div className="flua-skeleton rounded h-3 w-40" />
    </div>
  );
}

export function SkeletonFluaRow({ cols = 5 }) {
  return (
    <div className="flex items-center gap-4 py-3 border-b border-border/60" data-testid="skeleton-flua-row">
      {Array.from({ length: cols }).map((_, i) => (
        <div key={i} className={`flua-skeleton rounded h-3 ${i === 0 ? "w-40" : "flex-1"}`} aria-hidden />
      ))}
    </div>
  );
}

export default SkeletonFlua;
